import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { Typography, Button, Box, CircularProgress } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import '../components/connection/Connections.css';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import ConnectionTreeView from '../components/connection/ConnectionTreeView';
import { useAppSnackbar } from '../contexts/AppSnackbarContext';

export default function Connections() {
    const treeObj = useRef(null);
    const [selectedConnection, setSelectedConnection] = useState(null);
    const [selectedAction, setSelectedAction] = useState(null);
    const [refreshTree, setRefreshTree] = useState(0);
    const selectedNode = useRef({});
    const navigate = useNavigate();
    const location = useLocation();
    //const { showSnackbar } = useAppSnackbar();

    const handleNavigation = (path) => {
        if (location.pathname !== path) {
            navigate(path); // Navigate only if the path is different
        }
    };

    const handleNewConnection = () => {
        console.log(selectedNode.current);
        if (selectedNode.current.id) {
            let nodeData = treeObj.current.getTreeData(selectedNode.current.id);
            //Update the name text from backend.
            nodeData[0].selected = false;
            treeObj.current.refreshNode(selectedNode.current.id, nodeData);
        }
        handleNavigation('/connections/new');
    };

    const handleConnectionClick = (connection) => {
        handleNavigation(`/connections/${connection.id}/edit`);
    };

    const handleActionClick = (action) => {
        handleNavigation(`/connections/${action.connectionId}/actions/${action.id}/edit`);
    };

    const handleEventClick = (event) => {
        handleNavigation(`/connections/${event.connectionId}/events/${event.id}`);
    }

    const onNodeSelected = (nodeData) => {
        if (nodeData.treeViewType && nodeData.treeViewType === 'Connection') {
            handleConnectionClick(nodeData);
        }
        if (!nodeData.treeViewType) {
            if (nodeData.isAction) handleActionClick(nodeData);
            if (nodeData.isEvent) {
                handleEventClick(nodeData);
            }
        }
    };
    return (
        <Box style={{ height: '90vh', display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ width: "30%", borderRight: '1px solid #cccc', height: '100%', p: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'Column' }} >
                    <Typography variant="h4" gutterBottom>
                        Connections
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => handleNewConnection()}
                        sx={{ mb: 2 }}
                    >
                        + New Connection
                    </Button>
                </Box>
                <ConnectionTreeView
                    //dataSource={dataSource}
                    onNodeSelected={onNodeSelected}
                    selectedNode={selectedNode}
                    refreshTree={refreshTree}
                    //nodeTemplate={nodeTemplate}
                    //selectedNodes={selectedNodeIds}
                    reference={treeObj}
                />
            </Box>
            <Box sx={{ width: '70%', display: 'flex', flexDirection: 'column', p: 2 }}>
                <div style={{ overflow: 'auto', height: '100vh' }}> {/* Set a height for overflow to be effective */}
                    <Outlet  context={{
                        selectedConnection,
                        setSelectedConnection,
                        selectedAction,
                        setSelectedAction,
                        setRefreshTree,
                        handleNavigation
                    }} />
                </div>
                
            </Box>
        </Box>
    );
}
